// Import necessary action types, HttpService, and Post function
import {
    IncrementWebStoryViews_FETCH_DATA_SUCCESS,
    IncrementWebStoryViews_HAVE_ERROR,
    IncrementWebStoryViews_ARE_LOADING,
  } from "../actionType";
  import HttpService from "../../utils/httpService";
  import { Post } from "../../services/api.service";
  
  // Action creator function to handle different types of post actions
  export function IncrementWebStoryViewsAction(action, payload) {
    switch (action) {
      case IncrementWebStoryViews_HAVE_ERROR:
        // Return action object indicating error
        return {
          type: action,
          hasError: payload,
        };
  
      case IncrementWebStoryViews_ARE_LOADING:
        // Return action object indicating loading state and resetting Post data to null
        return {
          type: action,
          isLoading: payload,
          Post: null,
        };
  
      case IncrementWebStoryViews_FETCH_DATA_SUCCESS:
        // Return action object containing fetched post data
        return {
          type: action,
          Post: payload,
        };
  
      default:
        return;
    }
  }
  
  // Async action creator function to fetch post data based on provided URL
  // Optional: pageId and pageNumber for tracking individual page views
  export function IncrementWebStoryViewsFetchData(url, pageId = null, pageNumber = null) {
    return (dispatch) => {
      // Dispatch action to indicate data loading
      dispatch(IncrementWebStoryViewsAction(IncrementWebStoryViews_ARE_LOADING, true));

      // Prepare payload - include page info if provided
      const payload = { url: url };
      if (pageId) {
        payload.pageId = pageId;
      }
      if (pageNumber) {
        payload.pageNumber = pageNumber;
      }

      // Make a POST request to fetch post data based on provided URL
      return Post(HttpService.IncrementWebStoryViews, payload)
        .then((result) => {
          // Dispatch success action with fetched post data
          dispatch(IncrementWebStoryViewsAction(IncrementWebStoryViews_FETCH_DATA_SUCCESS, result.data));
          // Resolve the promise with the result
          return result;
        })
        .catch((error) => {
          // Dispatch error action if request fails and reject the promise
            dispatch(IncrementWebStoryViewsAction(IncrementWebStoryViews_HAVE_ERROR, true));
          return Promise.reject(error);
        });
    };
  }
  